import React from "react"
import Typography from "aldoo-ra/Typography"

const ProfileSection = ({ profile }) => {
  if (!profile) return null
  return (
    <div className="space-y-4 max-w-xl">
      <div className="p-4 rounded-lg bg-admin_paper">
        <div className="text-xs text-admin_muted">Name</div>
        <div className="font-medium">{profile.name || "(not set)"}</div>
      </div>
      <div className="p-4 rounded-lg bg-admin_paper">
        <div className="text-xs text-admin_muted">Email</div>
        <div className="font-medium">{profile.email || "(not set)"}</div>
      </div>
      <Typography variant="admin_body" className="text-admin_muted">
        Use Organizations to manage teams. Use Projects to monitor status components.
      </Typography>
    </div>
  )
}

export default ProfileSection
